import IndTeacherSettings from './Settings'
const IndTeacherService = {
  Settings: IndTeacherSettings,
}

export default IndTeacherService
